/** Please delete this file when mpNewSchedulerPage got turned on in prod  */

import moment from 'moment-timezone'
import { FORMATS } from 'constants/datetime'
import { stopTypes } from 'constants/facilities'

export const formatDate = date => moment(date).format(FORMATS.dayFormat)
export const currentStopType = stopType => stopTypes[stopType].toLowerCase()

export const confirmText = (stop, stopType) =>
  `PO #${stop.po} is confirmed to ${currentStopType(stopType)}`
export const alreadyConfirmedText = () => 'This appointment has already been confirmed'
export const appointmentDate = (stop, apptType) =>
  `${formatDate(stop.startAtDate)} (${stop.startAtTime} ${
    apptType === 'fcfs' && stop.endAtTime ? `- ${stop.endAtTime} ` : ''
  }${stop.timezone})`

// TODO remove after release
export const oldConfirmText = (stop, stopType, apptType) =>
  `PO #${stop.po} is confirmed to ${currentStopType(stopType)} on ${formatDate(
    stop.startAtDate
  )} at ${stop.startAtTime} ${apptType === 'fcfs' && stop.endAtTime ? `- ${stop.endAtTime} ` : ''}${
    stop.timezone
  }.`
export const oldAlreadyConfirmedText = stop =>
  `This appointment has already been confirmed for ${formatDate(stop.startAtDate)} at ${
    stop.startAtTime
  } ${stop.endAtTime ? `- ${stop.endAtTime} ` : ''}${stop.timezone}.`
